import { ContentType, OrganizationStatus } from ".";

export const CONTENT_TYPE_CATEGORY__ALL: ContentType = {
  friendlyId: "all",
  contentTypeId: "",
  displayName: "All",
  initial: true,
  contentColor: ""
};

export const ORGANIZATION_CONTENT_TYPE_CATEGORY__ALL: OrganizationStatus = {
  friendlyId: "all",
  displayName: "All",
  statusId: ""
};

export const CONTENT_TYPE_FILTER_TYPE_LABEL = {
  search: "Search",
  contentType: "Content Type"
};

export const CONTENT_TYPE_FILTER_TYPE_VALUE = {
  search: "search",
  contentType: "contentType"
};

export const CONTENT_TYPE_DEFAULT_PAGER_LIST = [5, 10, 25, 100];

export const CONTENT_TYPE_DEFAULT_PAGER_SKIP = 0;

export const CONTENT_TYPE_DEFAULT_PAGER_TAKE = 10;

export const DEFAULT_CONTENT_TYPES_QUERY_PARAMS = {
  take: CONTENT_TYPE_DEFAULT_PAGER_TAKE,
  skip: CONTENT_TYPE_DEFAULT_PAGER_SKIP,
  contentTypes: ORGANIZATION_CONTENT_TYPE_CATEGORY__ALL.friendlyId,
  search: null
};

export interface ContentTypesQueryParams {
  take: number | null;
  skip: number | null;
  contentTypes: string | null;
  search: string | null;
  sort: string | null;
  sortDirection: string | null;
}
